import React from "react";
import { Link } from "react-router-dom";

export default function About({ content = {} }) {
  const trustItems = content.items || [
    {
      title: "Approche terrain",
      text: "Des solutions pensées pour les réalités opérationnelles de nos clients.",
    },
    {
      title: "Accompagnement complet",
      text: "De l'analyse du besoin jusqu'au suivi des résultats.",
    },
    {
      title: "Réseau international",
      text: "Une présence et des relais pour soutenir les projets au-delà d'un seul marché.",
    },
  ];

  return (
    <section className="trust-band py-7 py-lg-9">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-12 col-lg-5">
            <p className="section-kicker mb-3">
              {content.kicker || "Pourquoi nous choisir"}
            </p>
            <h2 className="section-heading mb-4">
              {content.title ||
                "Une équipe polyvalente pour passer de l'idée à l'action."}
            </h2>
            <p className="text-muted mb-4">
              {content.description ||
                "Fatihoune réunit formation, conseil, assistance et services opérationnels pour apporter une réponse claire aux besoins des organisations et des particuliers."}
            </p>
            <Link to="/about" className="btn btn-success">
              {content.cta || "En savoir plus"}
            </Link>
          </div>

          <div className="col-12 col-lg-7">
            <div className="row g-4">
              {trustItems.map((item) => (
                <div className="col-12 col-md-4" key={item.title}>
                  <div className="trust-item">
                    <h3 className="h5 fw-bold mb-3">{item.title}</h3>
                    <p className="text-muted mb-0">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
